import { AppConfig, getConfig } from "../../config/runtimeConfig";
import * as PATH from "../Contants";
import { instance as Storage } from "../local-storage";

export type PreserveAuthFields = {
  lastMsg?: string | null;
  isPhone?: string | null;
  savedSchool?: string | null;
};

export function capturePreserveFields(): PreserveAuthFields {
  return {
    lastMsg: localStorage.getItem(PATH.LAST_MSG),
    isPhone: localStorage.getItem("isPhone"),
    savedSchool: localStorage.getItem("savedSchool"),
  };
}

export function clearLocalAuth(preserve?: PreserveAuthFields): void {
  const preserved = preserve ?? capturePreserveFields();
  localStorage.clear();
  if (preserved.lastMsg != null) {
    localStorage.setItem(PATH.LAST_MSG, preserved.lastMsg);
  }
  if (preserved.isPhone != null) {
    localStorage.setItem("isPhone", preserved.isPhone);
  }
  if (preserved.savedSchool != null) {
    localStorage.setItem("savedSchool", preserved.savedSchool);
  }
}

export function getHomeUrl(config?: AppConfig): string {
  const cfg = config ?? getConfig();
  const path = PATH.HOME_PATH || "/";
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  if (cfg.HOME_DOMAIN) {
    const base = cfg.HOME_DOMAIN.replace(/\/+$/, "");
    try {
      const homeHost = new URL(
        base.startsWith("http") ? base : `https://${base}`
      ).host;
      if (window.location.host === homeHost) {
        return normalizedPath === "/"
          ? `${base}/`
          : `${base}${normalizedPath}`;
      }
    } catch {
      // fall through to current origin
    }
  }

  return `${window.location.origin}${normalizedPath}`;
}

/** CAS 登出完成后由 SSO 重定向回站点首页（带 action=logout 供首页收尾） */
export function getCasLogoutCallbackUrl(config: AppConfig): string {
  const url = new URL(getHomeUrl(config));
  url.searchParams.set("action", "logout");
  return url.toString();
}

export function redirectToCasLogout(config: AppConfig): void {
  const centerUrl = getCasLogoutCallbackUrl(config);
  const serverUrl = config.SAML_SERVER_URL;
  const target = `${serverUrl}/cas/logout?centerUrl=${encodeURIComponent(
    centerUrl
  )}`;
  window.parent.parent.location.href = target;
}

export async function performOAuthLogout(config: AppConfig): Promise<void> {
  const token = Storage.accessToken;
  if (!token) {
    return;
  }
  try {
    await fetch(`${config.OAUTH_SERVER_URL}/oauth/logout`, {
      method: "GET",
      headers: {
        Authorization: `bearer ${token}`,
      },
      credentials: "include",
    });
  } catch (err) {
    console.log("performOAuthLogout", err);
  }
}

export type LogoutOptions = {
  handleUserInfo?: (userInfo: Record<string, never>) => void;
  onBeforeRedirect?: () => void;
};

export async function logout(options: LogoutOptions = {}): Promise<void> {
  const { handleUserInfo, onBeforeRedirect } = options;
  const config = getConfig();
  const preserve = capturePreserveFields();

  handleUserInfo?.({});
  clearLocalAuth(preserve);
  onBeforeRedirect?.();

  if (config.CAS_LOGIN === "true") {
    redirectToCasLogout(config);
    return;
  }

  await performOAuthLogout(config);
  clearLocalAuth(preserve);
  handleUserInfo?.({});
  window.location.replace(getHomeUrl(config));
}

export function finishCasLogoutCallback(
  handleUserInfo?: (userInfo: Record<string, never>) => void
): void {
  const config = getConfig();
  const preserve = capturePreserveFields();
  handleUserInfo?.({});
  clearLocalAuth(preserve);
  window.location.replace(getHomeUrl(config));
}
